import React, { useState, useContext } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import InputTypeFloat from '../../../common/components/InputTypeDecimalNumber/InputTypeFloat';
import './InPrincipalEditor.css';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import { BankListOptions } from '../../../common/constants/BankList';
import get from 'lodash/get';
import Modal from '../../../common/components/Modal/modal';
import PopUp from '../../../common/components/PopUp/PopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import AdditionalOffer from './AdditionalOffer';
import TermsRow from './TermsAndConditions/TermsRow';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { approveInPrinciple } from '../../../common/constants/api';
import _ from 'lodash';
import CommonCheckbox from '../../../common/components/CommonCheckBox/CommonCheckbox';

const updateLeadStatus = async setTriggerStatusUpdate => {
  if (localStorage.hasOwnProperty('applicantionInfo')) {
    let leadInfo = JSON.parse(localStorage.getItem('applicantionInfo'));
    leadInfo.applicationStatus = 'In Principle Accepted';
    localStorage.setItem('applicantionInfo', JSON.stringify(leadInfo));
    setTriggerStatusUpdate('In Principle Accepted');
  } else {
    throw new Error('applicationInfo Key word error in local storage');
  }
};
let tenureOptions = [
  {
    label: 'Year',
    value: 'Year'
  },
  {
    label: 'Month',
    value: 'Month'
  }
];
let RateTypeOptions = [
  {
    label: 'FLOATING',
    value: 'FLOATING'
  },
  {
    label: 'FIXED',
    value: 'FIXED'
  },
  {
    label: 'HYBRID',
    value: 'HYBRID'
  }
];
let ValidUptoOptions = [
  {
    label: '30 Days',
    value: '30'
  },
  {
    label: '90 Days',
    value: '90'
  },
  {
    label: '180 Days',
    value: '180'
  },
  {
    label: '360 Days',
    value: '360'
  }
];
const validationSchema = Yup.object().shape({
  SelectedType: Yup.string().required('Required'),
  bank: Yup.object().when('SelectedType', {
    is: 'Bank',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  requestedLoanAmount: Yup.string().required('Required'),
  tenureSelect: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  sanctionLoanAmount: Yup.string().required('Required'),
  interestRateType: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  baseRate: Yup.string()
    .required('Required')
    .test('baseRate', 'Can not be greater than 100%', function(val) {
      if (val != undefined) {
        let checkVal = parseInt(val.replace(/,/g, ''));
        if (checkVal >= 0 && checkVal <= 100) return true;
        else return false;
      }
    }),
  rateofInterest: Yup.string()
    .required('Required')
    .test('rateofInterest', 'Can not be greater than 100%', function(val) {
      if (val != undefined) {
        let checkVal = parseInt(val.replace(/,/g, ''));
        if (checkVal >= 0 && checkVal <= 100) return true;
        else return false;
      }
    }),
  loanTenure: Yup.string().when('tenureSelect.value', {
    is: 'Month',
    then: Yup.string()
      .required('Required')
      .test('loanTenure', 'Invalid', function(val) {
        if (val != undefined) {
          let checkVal = parseInt(val.replace(/,/g, ''));
          if (checkVal >= 12 && checkVal <= 360) return true;
          else return false;
        }
      }),
    otherwise: Yup.string().when('tenureSelect.value', {
      is: 'Year',
      then: Yup.string()
        .required('Required')
        .test('loanTenure', 'Invalid', function(val) {
          if (val != undefined) {
            let checkVal = parseInt(val.replace(/,/g, ''));
            if (checkVal >= 1 && checkVal <= 30) return true;
            else return false;
          }
        })
    })
  }),

  processingCharges: Yup.string()
    .required('Required')
    .test('processingCharges', 'Can not be greater than 100%', function(val) {
      if (val != undefined) {
        let checkVal = parseInt(val.replace(/,/g, ''));
        if (checkVal >= 0 && checkVal <= 100) return true;
        else return false;
      }
    }),
  GST: Yup.string()
    .required('Required')
    .test('GST', 'Can not be greater than 100%', function(val) {
      if (val != undefined) {
        let checkVal = parseInt(val.replace(/,/g, ''));
        if (checkVal >= 0 && checkVal <= 100) return true;
        else return false;
      }
    })
});
const InPrincipalEditor = ({ setTriggerStatusUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [Loading, setLoading] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('Loading...');
  const [goTo, setGoto] = useState(false);
  const [termsData, setTermsData] = useState({ data: [] });
  const [loanAmount, setLoanAmount] = useState(
    getApplicantionInfo().loanAmount
  );
  const [amountExceeds, setAmountExceeds] = useState(false);
  const { data } = termsData;

  return (
    <Formik
      initialValues={{
        SelectedType: 'Anonymous',
        bank: { value: '', label: 'Select Bank' },
        tenureSelect: { value: '', label: 'Select' },
        requestedLoanAmount: loanAmount,
        sanctionLoanAmount: '',
        interestRateType: { value: 'FLOATING', label: 'FLOATING' },
        baseRate: '',
        rateofInterest: '',
        loanTenure: '',
        processingCharges: '',
        GST: '',
        totalProceesAmount: '',
        additionalCharge: '',
        validupto: { value: '', label: 'Select' },
        sendEmail: false,

        loanOffers: [],
        terms: []
      }}
      validationSchema={validationSchema}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        const addAdditionalOffer = () => {
          if (
            values?.sanctionLoanAmount != '' &&
            values?.tenureSelect?.value != '' &&
            values?.loanTenure != ''
          ) {
            if (parseInt(values?.sanctionLoanAmount) > parseInt(loanAmount)) {
              setLoading(true);
              setPopUpType('fail');
              setPopUpText(
                'Sanction Loan Amount can not be greater than Requested Loan Amount!'
              );
              setGoto(false);
            } else {
              setShowModal(true);
            }
          } else {
            setLoading(true);
            setPopUpType('fail');
            setPopUpText(
              'Please fill Sanction Loan Amount and Loan Tenure first!'
            );
            setGoto(false);
          }
        };
        const checkLoanAmount = () => {
          if (values?.sanctionLoanAmount > loanAmount) {
            setAmountExceeds(true);
          } else {
            setAmountExceeds(false);
          }
        };

        let ProcessAmt = parseFloat(
          (values?.sanctionLoanAmount * parseFloat(values?.processingCharges)) /
            100 || 0
        );
        let TotProcessAmt =
          ProcessAmt +
          parseInt((ProcessAmt * parseFloat(values?.GST)) / 100 || 0);
        values.totalProceesAmount = Math.round(TotProcessAmt);

        async function onApproveinPrincipal() {
          setLoading(true);
          setPopUpType('loading');
          setPopUpText('Loading...');
          let loanTenure = '';
          if (values?.tenureSelect?.value == 'Year') {
            loanTenure = parseInt(values?.loanTenure) * 12;
          } else {
            loanTenure = values?.loanTenure;
          }
          let SelectedBankType;
          if (values?.SelectedType == 'Anonymous') {
            SelectedBankType = 'Anonymous';
          } else {
            SelectedBankType = values?.bank?.value;
          }

          let body = {
            bankName: SelectedBankType,
            loanAmount: values?.requestedLoanAmount,
            sanctionAmount: values?.sanctionLoanAmount,
            interestRateType: values?.interestRateType.value,
            baseRate: values?.baseRate,
            roi: values?.rateofInterest,
            loanTenureInMonths: loanTenure,
            processingCharges: values?.processingCharges,
            gst: values?.GST,
            emailCustomer: values?.sendEmail,
            totalProcessingCharges: Math.round(TotProcessAmt),
            additionalCharges: values?.additionalCharge,
            validUpto: values?.validupto?.value,
            loanOffers: values?.loanOffers.map(each => {
              return {
                loanAmountOffer: values?.requestedLoanAmount,
                offerName: each?.offerType,
                additionalAmount: each?.additionalAmount,
                roi: each?.rateOfInterestOffer,
                emi: each?.EMI
              };
            }),
            termsAndCondition: values?.terms.map(each => {
              return each?.text;
            })
          };

          try {
            const saveapprove = await approveInPrinciple(leadId, body);
            if (!saveapprove.isAxiosError) {
              setPopUpType('success');
              setPopUpText('In Principle Indication has been created!');
              setGoto(true);
              updateLeadStatus(setTriggerStatusUpdate);
            } else {
              setPopUpType('fail');
              setPopUpText('something went wrong!');
              setLoading(true);
            }
          } catch (err) {
            err?.response?.data?.status === 403
              ? setGoto(true)
              : setGoto(false);
            setPopUpType('fail');
            setPopUpText(err?.response?.data?.message);
          }
        }

        function addNewOffer(
          offertype,
          additionalAmount,
          rateOfInterestOffer,
          emi
        ) {
          const addNewOfferData = [...values.loanOffers];
          addNewOfferData.push({
            offerType: offertype,
            additionalAmount: additionalAmount,
            rateOfInterestOffer: rateOfInterestOffer,
            EMI: emi
          });
          setFieldValue('loanOffers', addNewOfferData);
        }

        function onDeleteOffer(index) {
          const delNewOfferData = [...values.loanOffers];
          delNewOfferData.splice(index, 1);
          setFieldValue('loanOffers', delNewOfferData);
        }

        // terms code

        function onDelete(index) {
          const newData = [...values.terms];
          newData.splice(index, 1);

          setFieldValue('terms', newData);
        }
        function addNewTerms(passText) {
          const addNewData = [...values.terms];
          addNewData.push({
            text: passText
          });
          setFieldValue('terms', addNewData);
        }

        return (
          <React.Fragment>
            {Loading && (
              <PopUp
                type={popUpType}
                text={popUpText}
                show={Loading}
                setShow={setLoading}
                goto={goTo}
              />
            )}
            <Form className="w-full">
              <div className="bg-white py-8 md:py-2 px-5 md:mx-10 border border-navy-400 my-10">
                <p className="font-roboto font-bold text-black text-2xl px-2 mb-5">
                  In-Principal Editor
                </p>

                <div className="w-full md:flex block py-3 px-2">
                  <div className="flex-row-reverse flex md:flex-row ">
                    <RadioButton
                      name="SelectedType"
                      value={values?.SelectedType == 'Anonymous' ? true : false}
                      checked={
                        values?.SelectedType == 'Anonymous' ? true : false
                      }
                      onChange={e => {
                        handleChange(e),
                          setFieldValue('SelectedType', 'Anonymous');
                      }}
                      onBlur={handleBlur}
                    />
                    <p className="font-roboto font-normal text-grey-2000 px-2 mr-auto">
                      Anonymous
                    </p>
                  </div>
                  <div className="mr-auto flex md:ml-10 flex-row-reverse md:flex-row py-2 md:py-0">
                    <RadioButton
                      name="SelectedType"
                      value={values?.SelectedType == 'Bank' ? true : false}
                      checked={values?.SelectedType == 'Bank' ? true : false}
                      onChange={e => {
                        handleChange(e), setFieldValue('SelectedType', 'Bank');
                      }}
                      onBlur={handleBlur}
                    />
                    <p className="font-roboto font-normal text-grey-2000 px-2 mr-auto">
                      Bank
                    </p>
                  </div>
                </div>
                {values?.SelectedType == 'Bank' && (
                  <div className="lg:w-3/12 md:w-3/12 w-full px-3">
                    <CommonSelect sort={true}
                      name="bank"
                      value={values.bank}
                      onChange={e => {
                        setFieldValue('bank', {
                          value: e.value,
                          label: e.value
                        });
                      }}
                      onBlur={() => {
                        setFieldTouched('bank', true, true);
                      }}
                      sort={true}
                      options={BankListOptions}
                      isHoverEffect
                      stylesContainer={{
                        marginBottom: '0px',
                        fontSize: '40px',
                        height: '52px'
                      }}
                      dropdownStyle={{
                        top: '52px',
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        backgroundColor: '#fff',
                        alignItems: 'center',
                        fontFamily: 'Roboto',
                        fontWeight: 400
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 6px',
                        backgroundColor: 'white'
                      }}
                      error={touched.bank && get(errors, 'bank.value', false)}
                      touched={touched.bank}
                    />
                  </div>
                )}
                <div className="w-full xl:flex mt-6">
                  <div className="xl:w-4/12 w-full px-3">
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Requested Loan Amount
                        </p>
                      </div>
                      <div>
                        <InputTypeNumber
                          name="requestedLoanAmount"
                          value={values.requestedLoanAmount}
                          maxLength={15}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{
                            height: '30px',
                            fontWeight: 'normal',
                            paddingLeft: '40px',
                            paddingTop: '2px',
                            letterSpacing: '1px'
                          }}
                          iconStyle={{ marginTop: '12px' }}
                          error={
                            touched.requestedLoanAmount &&
                            errors.requestedLoanAmount
                          }
                          errorMsg={errors.requestedLoanAmount}
                          touched={touched.requestedLoanAmount}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showInText={false}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div
                      className={`${
                        amountExceeds === true
                          ? 'grid grid-cols-2 mb-4 xl:mt-8  mt-6'
                          : 'grid grid-cols-2 mb-4 mt-6'
                      }`}
                    >
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">Base Rate %</p>
                      </div>
                      <div>
                        <InputTypeFloat
                          name="baseRate"
                          value={values.baseRate}
                          maxLength={10}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{ height: '30px' }}
                          error={touched.baseRate && errors.baseRate}
                          errorMsg={errors.baseRate}
                          rupeeIcon={false}
                          touched={touched.baseRate}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Processing Charges %
                        </p>
                      </div>
                      <div>
                        <InputTypeFloat
                          name="processingCharges"
                          value={values.processingCharges}
                          maxLength={15}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{ height: '30px' }}
                          error={
                            touched.processingCharges &&
                            errors.processingCharges
                          }
                          rupeeIcon={false}
                          errorMsg={errors.processingCharges}
                          touched={touched.processingCharges}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Additional Charge
                        </p>
                      </div>
                      <div>
                        <InputTypeNumber
                          name="additionalCharge"
                          value={values.additionalCharge}
                          maxLength={10}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{
                            height: '30px',
                            fontWeight: 'normal',
                            paddingLeft: '40px',
                            paddingTop: '2px',
                            letterSpacing: '1px'
                          }}
                          iconStyle={{ marginTop: '12px' }}
                          error={
                            touched.additionalCharge && errors.additionalCharge
                          }
                          errorMsg={errors.additionalCharge}
                          touched={touched.additionalCharge}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showInText={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="xl:w-4/12 w-full px-3">
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Sanction Loan Amount
                        </p>
                      </div>
                      <div>
                        <InputTypeNumber
                          name="sanctionLoanAmount"
                          value={values.sanctionLoanAmount}
                          maxLength={15}
                          minLength={0}
                          onChange={handleChange}
                          onKeyUp={checkLoanAmount()}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{
                            height: '30px',
                            fontWeight: 'normal',
                            paddingLeft: '40px',
                            paddingTop: '2px',
                            letterSpacing: '1px'
                          }}
                          iconStyle={{ marginTop: '12px' }}
                          error={
                            touched.sanctionLoanAmount &&
                            errors.sanctionLoanAmount
                          }
                          errorMsg={errors.sanctionLoanAmount}
                          touched={touched.sanctionLoanAmount}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showInText={false}
                        />
                        {amountExceeds ? (
                          <p
                            className="mt-1 font-medium text-red-300"
                            style={{ fontSize: '0.57rem' }}
                          >
                            Should be less than Loan Amount
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <div
                      className={`${
                        amountExceeds
                          ? 'grid grid-cols-2 mb-4 xl:mt-4 mt-6'
                          : 'grid grid-cols-2 mb-4 mt-6'
                      }`}
                    >
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Rate of Interest %
                        </p>
                      </div>
                      <div>
                        <InputTypeFloat
                          name="rateofInterest"
                          value={values.rateofInterest}
                          maxLength={10}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{ height: '30px' }}
                          error={
                            touched.rateofInterest && errors.rateofInterest
                          }
                          rupeeIcon={false}
                          errorMsg={errors.rateofInterest}
                          touched={touched.rateofInterest}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showInText={false}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">GST %</p>
                      </div>
                      <div>
                        <InputTypeFloat
                          name="GST"
                          value={values.GST}
                          maxLength={10}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{ height: '30px' }}
                          rupeeIcon={false}
                          error={touched.GST && errors.GST}
                          errorMsg={errors.GST}
                          touched={touched.GST}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs ">Valid upto</p>
                      </div>
                      <div>
                        <CommonSelect sort={true}
                          name="validupto"
                          value={values.validupto}
                          onChange={e => {
                            setFieldValue('validupto', {
                              value: e.value,
                              label: e.value
                            });
                          }}
                          onBlur={() => {
                            setFieldTouched('validupto', true, true);
                          }}
                          options={ValidUptoOptions}
                          isHoverEffect
                          stylesContainer={{
                            marginBottom: '0px',
                            fontSize: '40px',
                            height: '45px',
                            maxWidth: '300px'
                          }}
                          inputStyle={{ height: '30px' }}
                          dropdownStyle={{
                            top: '52px',
                            color: 'rgba(0,0,0,0.87)',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 6px',
                            backgroundColor: 'white'
                          }}
                          error={
                            touched.validupto &&
                            get(errors, 'validupto.value', false)
                          }
                          touched={touched.validupto}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="xl:w-4/12 w-full px-3">
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Interest Rate Type
                        </p>
                      </div>
                      <div>
                        <CommonSelect sort={true}
                          name="interestRateType"
                          value={values.interestRateType}
                          onChange={e => {
                            setFieldValue('interestRateType', {
                              value: e.value,
                              label: e.value
                            });
                          }}
                          onBlur={() => {
                            setFieldTouched('interestRateType', true, true);
                          }}
                          options={RateTypeOptions}
                          isHoverEffect
                          stylesContainer={{
                            marginBottom: '0px',
                            fontSize: '40px',
                            height: '45px',
                            maxWidth: '300px'
                          }}
                          inputStyle={{ height: '30px' }}
                          dropdownStyle={{
                            top: '52px',
                            color: 'rgba(0,0,0,0.87)',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 6px',
                            backgroundColor: 'white'
                          }}
                          error={
                            touched.interestRateType &&
                            get(errors, 'interestRateType.value', false)
                          }
                          touched={touched.interestRateType}
                        />
                      </div>
                    </div>
                    <div
                      className={`${
                        amountExceeds
                          ? 'grid grid-cols-2 mb-4 xl:mt-8 mt-6'
                          : 'grid grid-cols-2 mb-4 mt-6'
                      }`}
                    >
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">Loan Tenure</p>
                      </div>
                      <div className="flex" style={{ maxWidth: '300px' }}>
                        <InputTypeNumber
                          name="loanTenure"
                          value={values.loanTenure}
                          maxLength={10}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{ height: '30px' }}
                          showInText={false}
                          rupeeIcon={false}
                          error={touched.loanTenure && errors.loanTenure}
                          errorMsg={errors.loanTenure}
                          touched={touched.loanTenure}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                        />
                        <CommonSelect sort={true}
                          name="tenureSelect"
                          value={values.tenureSelect}
                          onChange={e => {
                            setFieldValue('tenureSelect', {
                              value: e.value,
                              label: e.value
                            });
                          }}
                          onBlur={() => {
                            setFieldTouched('tenureSelect', true, true);
                          }}
                          options={[
                            {
                              label: 'Select',
                              value: ''
                            },
                            ...tenureOptions
                          ]}
                          isHoverEffect
                          stylesContainer={{
                            marginBottom: '0px',
                            fontSize: '40px',
                            height: '45px'
                          }}
                          inputStyle={{ height: '30px' }}
                          dropdownStyle={{
                            top: '52px',
                            color: 'rgba(0,0,0,0.87)',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 6px',
                            backgroundColor: 'white'
                          }}
                          error={
                            touched.tenureSelect &&
                            get(errors, 'tenureSelect.value', false)
                          }
                          touched={touched.tenureSelect}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mb-4 mt-6">
                      <div className="labels lg:p-2 md:p-3 p-1 rounded mr-2">
                        <p className="text-gray-500 text-xs">
                          Total Processing Amount
                        </p>
                      </div>
                      <div>
                        <InputTypeNumber
                          name="totalProceesAmount"
                          value={values.totalProceesAmount}
                          maxLength={15}
                          minLength={0}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          stylesContainer={{ height: '45px' }}
                          inputStyle={{
                            height: '30px',
                            fontWeight: 'normal',
                            paddingLeft: '40px',
                            paddingTop: '2px',
                            letterSpacing: '1px'
                          }}
                          iconStyle={{ marginTop: '12px' }}
                          disabled={true}
                          error={
                            touched.totalProceesAmount &&
                            errors.totalProceesAmount
                          }
                          errorMsg={errors.totalProceesAmount}
                          touched={touched.totalProceesAmount}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          showInText={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="p-2 mx-2 rounded"
                  style={{ color: '#FF8000', backgroundColor: '#fdeedc' }}
                  onClick={addAdditionalOffer}
                >
                  <FontAwesomeIcon icon={faPlusCircle} />
                  <span className="px-1"> Add Additional Offer</span>
                </button>
                {values?.loanOffers != '' && (
                  <div className="w-full p-8 md:flex">
                    <div className="flex-row offer_box w-full md:w-2/12 text-green-500 text-left p-2 hidden md:block">
                      <span className="block p-1 px-2 h-12"></span>
                      <span className="block p-1 px-2">Interest Rate</span>
                      <span className="block p-1 px-2">Monthly EMI</span>
                      <span className="block p-1 px-2">Loan Amount</span>
                    </div>

                    {values?.loanOffers?.map((each, index) => {
                      return (
                        <div
                          className=" flex-row offer_box w-full xl:w-2/12 md:w-12/12 m-2 "
                          style={{ backgroundColor: '#e8fdfe' }}
                        >
                          <AdditionalOffer
                            isDisplayMode
                            InPrincipalValue={values}
                            key={index}
                            each={each}
                            onDeleteOffer={onDeleteOffer}
                            index={index}
                            onSubmitAction={() => {}}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="mt-6 mx-3 flex">
                  <div>
                    <p className="text-grey-600 pr-6">
                      Permission to send email by RM/BP
                    </p>
                  </div>
                  <CommonCheckbox
                    checked={values?.sendEmail || false}
                    name="sendEmail"
                    value={values.sendEmail}
                    onChange={e => {
                      setFieldValue('sendEmail', e.target.checked, true);
                      setFieldTouched('sendEmail', true, false);
                    }}
                    onBlur={handleBlur}
                  />
                </div>

                <div className="w-full px-3 text-sm pt-7">
                  {values?.terms != '' && (
                    <p className="text-grey-600 pb-2">Additional Conditions</p>
                  )}

                  {values?.terms?.map((each, index) => {
                    return (
                      <TermsRow
                        index={index}
                        data={each}
                        onDelete={onDelete}
                        setTerms={setTermsData}
                      />
                    );
                  })}

                  <TermsRow isCreateMode addNewTerms={addNewTerms} />
                </div>
                <button
                  className="submitButton text-14 w-56 h-12 font-medium font-roboto "
                  type="submit"
                  onClick={e => {
                    onApproveinPrincipal();
                  }}
                  disabled={!_.isEmpty(errors) || amountExceeds == true}
                  style={{
                    marginLeft: ' auto ',
                    marginRight: 'auto',
                    marginTop: '2rem',
                    marginBottom: '2rem'
                  }}
                >
                  Submit & Send
                </button>
              </div>
              <Modal show={showModal} setShow={setShowModal} xl={true}>
                {values?.loanOffers?.length <= 3 ? (
                  <AdditionalOffer
                    isAddMode
                    InPrincipalValue={values}
                    onSubmitAction={(values, actions) => {
                      addNewOffer(
                        values?.offerName?.value,
                        values?.additionalAmount,
                        values?.rateOfInterestOffer,
                        values?.EMI
                      );
                      setShowModal(false);
                    }}
                  />
                ) : (
                  <div className="text-grey-920 text-base font-roboto font-medium w-full text-center my-7">
                    You can add maximum 4 Additional Offers!
                  </div>
                )}
              </Modal>
            </Form>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};
export default InPrincipalEditor;
